import { FieldType } from '@/manual-review/form';

import validate from '@/manual-review/validations';
import {
  Document,
} from './types';

const cuiRegexp = /^[0-9]{8}$/;

export function validateDocumentNumber(value: string): string | boolean {
  if (!cuiRegexp.test(value)) {
    return 'Digite un CUI válido de 8 dígitos';
  }

  return true;
}

const doc: Document = {
  sides: {
    front: {
      fields: [
        {
          type: FieldType.Select,
          name: 'document_version',
          label: 'Versión de documento',
          rules: [validate.isRequired],
          value: '',
          options: [
            { label: '2005', value: 'pe_national-id-2005' },
            { label: '2013', value: 'pe_national-id-2013' },
            { label: '2020', value: 'pe_national-id-2020' },
          ],
          alwaysRequired: true,
        },
        {
          type: FieldType.Text,
          name: 'document_number',
          label: 'CUI',
          rules: [validate.isRequired, validateDocumentNumber],
          value: '',
        },
        {
          type: FieldType.Text,
          name: 'name',
          label: 'Prenombres',
          rules: [validate.isRequired, validate.name],
          value: '',
        },
        {
          type: FieldType.Text,
          name: 'last_name',
          label: 'Primer y segundo apellido',
          rules: [validate.isRequired, validate.name],
          value: '',
        },
        {
          type: FieldType.Select,
          name: 'gender',
          label: 'Sexo',
          rules: [validate.isRequired],
          value: '',
          options: [
            { label: 'Masculino', value: 'male' },
            { label: 'Femenino', value: 'female' },
          ],
        },
        {
          type: FieldType.Date,
          name: 'date_of_birth',
          label: 'Fecha de nacimiento',
          rules: [validate.isRequired, validate.isDate, validate.dateOfBirth],
          allowedDates: validate.dateOfBirth,
          value: '',
        },
        {
          type: FieldType.Date,
          name: 'expedition_date',
          label: 'Fecha de emisión',
          rules: [validate.isRequired, validate.isDate, validate.dateOfExpedition],
          allowedDates: validate.dateOfExpedition,
          value: '',
        },
        {
          type: FieldType.Text,
          name: 'birth_place',
          label: 'Ubigeo de nacimiento',
          rules: [validate.isRequired, validate.number],
          value: '',
        },
        {
          type: FieldType.Date,
          name: 'expiration_date',
          label: 'Fecha de caducidad',
          rules: [validate.isDate, validate.dateOfExpiration],
          allowedDates: validate.dateOfExpiration,
          value: '',
        },
      ],
    },
    reverse: {
      fields: [
        {
          type: FieldType.Text,
          name: 'residence_address',
          label: 'Dirección',
          rules: [validate.place],
          value: '',
        },
        {
          type: FieldType.Text,
          name: 'state_name',
          label: 'Departamento',
          rules: [validate.place],
          value: '',
        },
        {
          type: FieldType.Text,
          name: 'province',
          label: 'Provincia',
          rules: [validate.place],
          value: '',
        },
        {
          type: FieldType.Text,
          name: 'district',
          label: 'Distrito',
          rules: [validate.place],
          value: '',
        },
      ],
    },
  },
};

export default doc;
